import request from '@/utils/request'

const api = {
  upload: 'file/upload'
}
export default {
  upload(parameter) {
    return request({
      url: api.upload,
      method: 'post',
      data: parameter
    })
  }
}
